import { RootState } from 'store';

export const getAllTranslationsSelector = (state: RootState) => state.translations.translations;
